import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-profile',
  templateUrl: './change-profile.component.html',
  styleUrls: ['./change-profile.component.scss']
})
export class ChangeProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
